import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./routes/Home";
import EwgRedesign from "./routes/projects/EwgRedesign";
import MotionVideo from "./routes/projects/MotionVideo";
import Navbar from "./components/navbar";

import { LocomotiveScrollProvider } from "react-locomotive-scroll";
import { useRef, useEffect } from "react";
import "locomotive-scroll/dist/locomotive-scroll.css";
import { useLocomotiveScroll } from "react-locomotive-scroll";
import { PreloadProvider } from "./components/helpers/preloadMedia";

function App() {
  const containerRef = useRef(null);

  const options = {
    smooth: true,
  };

  const ScrollManager = () => {
    const { scroll } = useLocomotiveScroll();
    const location = useLocation();

    useEffect(() => {
      setTimeout(() => {
        scroll?.update();
      }, 100);
    }, [location.pathname]);

    return null;
  };

  return (
    <>
      <PreloadProvider>
        <LocomotiveScrollProvider options={options} containerRef={containerRef}>
          <ScrollManager />
          <main data-scroll-container ref={containerRef}>
            <Navbar />

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/projects/1" element={<EwgRedesign />} />
              <Route path="/projects/3" element={<MotionVideo />} />
            </Routes>
          </main>
        </LocomotiveScrollProvider>
      </PreloadProvider>
    </>
  );
}

export default App;
